module.exports = __webpack_public_path__ + "img/CommercialAndIndustrialCleaning.c752ff51.jpg";